export default __webpack_public_path__ + "static/media/image_075_0000.c503214b.png";